import { DialogBase } from '@scale/dialog-base';
import { ModalOpenEvent, ModalCloseEvent } from '@scale/events';

class ScaleModal extends DialogBase {
  onDialogOpen() {
    this.broadcast(new ModalOpenEvent(this.id));
  }

  onDialogClose() {
    this.broadcast(new ModalCloseEvent(this.id));
  }
}

if (!customElements.get('scale-modal')) {
  customElements.define('scale-modal', ScaleModal);
}
